var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"qiqiuImg",class:_vm.started},[_c('div',{staticClass:"qiqiu"},[_c('img',{attrs:{"src":_vm.tupian}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }